import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Accordion } from 'core/controls';
import SimpleOptionGroup from '../common/options/SimpleOptionGroup';
import { useModelInfo } from '../common/ModelInfoContext';
import OptionsPage from '../common/OptionsPage';

const Accessories = ({ groups }) => {
  const modelInfo = useModelInfo();
  return (
    <OptionsPage>
      {({ onChange, onDetails }) => (
        <Accordion>
          {groups.map(group => (
            <SimpleOptionGroup
              key={group.id}
              header={group.id}
              isOpenDefault={
                group.expanded || modelInfo.isAccessoriesOpenDefault
              }
              options={group.options}
              analyticsKey={group.id}
              onChange={onChange}
              onDetails={onDetails}
            />
          ))}
        </Accordion>
      )}
    </OptionsPage>
  );
};

const mapStateToProps = state => {
  return { groups: state.config.accessories };
};

export default withRouter(connect(mapStateToProps)(Accessories));
